export const BASE_Z = -400;
export {syncStage} from './syncStages';



// WEBPACK FOOTER //
// ./src/stage/scene/common.js